import { render, staticRenderFns } from "./AreaPhysicalLocation.vue?vue&type=template&id=0c06a212&scoped=true&lang=pug&"
import script from "./AreaPhysicalLocation.vue?vue&type=script&lang=js&"
export * from "./AreaPhysicalLocation.vue?vue&type=script&lang=js&"
import style0 from "./AreaPhysicalLocation.vue?vue&type=style&index=0&id=0c06a212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06a212",
  null
  
)

export default component.exports